export default __webpack_public_path__ + "static/media/slide-item3.5d4f14de.svg";